import { type ReorderMachineGuard, type ReorderStep } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const checkIfCanCancelStep: ReorderMachineGuard<{
  requestedStep: ReorderStep;
  currentStep: ReorderStep;
}> = (_args, params) => {
  return !params.requestedStep || params.requestedStep === params.currentStep;
};
